export const ROLE_USER_TYPE_HOST = 'host';
export const ROLE_USER_TYPE_ADVERTISER = 'advertiser';
export const ROLE_USER_TYPE_SYSTEM = 'system';

export const ROLE_AUTHORITY_TYPE_USER = 'user';
export const ROLE_AUTHORITY_TYPE_ADMIN = 'admin';
